import React, { useCallback } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import useQuery from '@/hooks/useQuery';
import Layout from '@/components/Layout';
import { StoreProvider } from '@/providers/storeProvider';
import AccWrapper from '@/components/AccWrapper';
import { airTracker } from '@/utils/airTracker';
import ErrorPage from '../Error';
import StatsigProvider from '@/providers/statsigProvider';
import { trace } from '@/utils/trace';
export const COMPONENT_NAME = 'hosted-invoice';

const Main = () => {
  const { s: signature } = useQuery<{ s: string }>();

  const logError = (error: Error, info: { componentStack: string }) => {
    airTracker.error('hosted-invoice-errorBoundary', {
      message: error?.message,
      stack: error?.stack,
      componentStack: info.componentStack,
    });
  };

  const handleLayoutRendered = useCallback(() => {
    trace.mark('root_component_ready');
  }, []);

  return (
    <ErrorBoundary fallback={<ErrorPage />} onError={logError}>
      <StoreProvider signature={signature}>
        <StatsigProvider>
          <AccWrapper>
            <Layout onRendered={handleLayoutRendered} />
          </AccWrapper>
        </StatsigProvider>
      </StoreProvider>
    </ErrorBoundary>
  );
};

export default Main;
